export default __webpack_public_path__ + "static/media/marketplace-tutors.5865a924.png";